import isEmpty from 'lodash/isEmpty';
import isEqual from 'lodash/isEqual';

const hasLocalStorage: boolean = !!(typeof window !== "undefined" && window.localStorage);

type IjobCorner = {
	backgroundImage: string,
	button_name: string,
	ctaLabel: string,
	description: string,
	id: number,
	image: string,
	message: string,
	url: string
}

type IjobCornerLocals = {
	currentIndex: number,
	bannerList: IjobCorner[]
}

export class JobCorner {
	constructor() {

	}

	getJobCornerStorage() {
		if (hasLocalStorage) {
			let jobCorner: any = localStorage.getItem("jobCorner");
			jobCorner = jobCorner ? JSON.parse(jobCorner) : '';
			return jobCorner
		}
		return {}
	}

	randomizedJobCorner(bannerList) {
		if (hasLocalStorage) {
			const jobCornerLocals: (IjobCorner[] | any) = this.getJobCornerStorage();

			if (isEmpty(jobCornerLocals) || !isEqual(jobCornerLocals.bannerList, bannerList)) {
				this.setJobCornerStorage(bannerList, 0)
				return bannerList[0]
			}
			else {
				const newIndex: number = jobCornerLocals.currentIndex >= jobCornerLocals.bannerList.length - 1 ? 0 : jobCornerLocals.currentIndex + 1;
				this.setJobCornerStorage(bannerList, newIndex);
				return bannerList[newIndex]
			}
		}
		return {}
	}

	setJobCornerStorage(bannerList, newIndex) {
		if (hasLocalStorage) {
			const jobCornerLocals: (IjobCornerLocals | any) = {
				bannerList: bannerList,
				currentIndex: newIndex
			}
			localStorage.setItem('jobCorner', JSON.stringify(jobCornerLocals))
		}
	}
}

const JobCornerService = new JobCorner();
export default JobCornerService;
